var exports = {
  "UD": "xe30f6088--d1d3df--footer-links-container",
  "KT": "xe30f6088--d1d3df--footer-links",
  "mt": "xe30f6088--d1d3df--footer-links-item",
};

module.exports = exports;
